import { useCallback, useEffect, useRef } from 'react';

import { componentsRegistry } from '../services/componentsRegistry';
import { useFlag } from '../services/launchDarkly';
import { useStores } from '../stores/useStores';

import { useMissedCountrySettings } from './useMissedCountrySettings';
import { useMissedWelcomeBonus } from './useMissedWelcomeBonus';

export function useForceDialogsBeforeFeatureManager() {
  const isSignUpUiRedesignEnabled = useFlag('ui_redesign_registration_flow', true);
  const { uiStore, portalStore, authStore, locationStore } = useStores();

  const { checkCountrySetMissed, showCountrySetDialog } = useMissedCountrySettings();
  const { checkWelcomeBonusMissed, showWelcomeBonusDialog } = useMissedWelcomeBonus();
  const { authStatus } = authStore;

  const isAllChecksPassed = useRef(false);

  const openPostSignUpWizard = useCallback(() => {
    portalStore.openPortal(componentsRegistry.getComponent('postSignUpWizard'), {
      persistent: true,
      contentClassName: 'fullscreen-modal-content',
      portalClassName: 'fullscreen-modal',
      overlayClassName: 'fullscreen-modal-overlay',
    });
  }, [portalStore]);

  const onCountryMissed = useCallback(() => {
    if (isSignUpUiRedesignEnabled) {
      openPostSignUpWizard();
    } else {
      showCountrySetDialog();
    }
  }, [isSignUpUiRedesignEnabled, openPostSignUpWizard, showCountrySetDialog]);

  useEffect(() => {
    if (
      !portalStore.isVisible &&
      uiStore.openDialog?.dialog === null &&
      !isAllChecksPassed.current &&
      authStatus === 'authenticated'
    ) {
      const isCountrySetMissed = checkCountrySetMissed();
      const isWelcomeBonusMissed = checkWelcomeBonusMissed();

      if (isCountrySetMissed) {
        onCountryMissed();
        return;
      }

      if (isWelcomeBonusMissed) {
        showWelcomeBonusDialog();
        return;
      }

      if (locationStore.shouldShowLocationRestrictedDialog) {
        locationStore.showLocationRestrictedDialog();
        return;
      }

      isAllChecksPassed.current = true;
    }
  }, [
    authStatus,
    onCountryMissed,
    checkCountrySetMissed,
    checkWelcomeBonusMissed,
    showWelcomeBonusDialog,
    portalStore.isVisible,
    uiStore.openDialog,
    locationStore,
  ]);
}
